import { render, staticRenderFns } from "./applyhs.vue?vue&type=template&id=70348b43&scoped=true"
import script from "./applyhs.vue?vue&type=script&lang=js"
export * from "./applyhs.vue?vue&type=script&lang=js"
import style0 from "./applyhs.vue?vue&type=style&index=0&id=70348b43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70348b43",
  null
  
)

export default component.exports